<template>
    <Breadcrumbs main="Form Controls" title="Validation Forms" />
    <div class="container-fluid">
        <div class="row">
            <toltipValidation />
            <browserDefaults />
            <validationForm />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const toltipValidation = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/validation/toltipValidation.vue"))
const browserDefaults = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/validation/browserDefaults.vue"))
const validationForm = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/validation/validationForm.vue"))
</script>